import React from "react";

const ButtonSpinner = () => {
  return <i className="fa fa-spinner fa-spin me-1" />;
};

export default ButtonSpinner;
